<div [appEnforcePermission]="authConfig.contactsProfileContactInformationViewAssigned"
  #contactsProfileContactInformationViewAssigned="appEnforcePermission"></div>
<div [appEnforcePermission]="authConfig.contactsProfileCompanyInformationView"
  #contactsProfileCompanyInformationView="appEnforcePermission"></div>
<div [appEnforcePermission]="authConfig.contactsInvestigations" #contactsInvestigations="appEnforcePermission"></div>

<span kendoPopoverAnchor [popover]="popoverRef" #anchor="kendoPopoverAnchor" showOn="hover"
  (mouseenter)="handleIconClick()">
  <a class="linkmd text-decoration"
    *ngIf="contactsInvestigations?.enabled || contactsProfileCompanyInformationView?.enabled || contactsProfileContactInformationViewAssigned?.enabled; else noPermission"
    [routerLink]="['/contacts/', billTo.id]">{{billTo | fullName}}</a>
  <ng-template #noPermission>{{billTo | fullName}}</ng-template>
  &nbsp;<i class="fa-solid fa-question-circle cursor-pointer">
  </i>
</span>
<kendo-popover [callout]="true" (hidden)="data = null" #popoverRef>
  <ng-template kendoPopoverBodyTemplate>
    <div class="popover-wrapper">

      <kendo-loader type="infinite-spinner" themeColor="primary" size="medium"
        *ngIf="billToPopoverLoading; else showPopoverData">
      </kendo-loader>

      <ng-template #showPopoverData>
        <kendo-gridlayout [rows]="['auto']" [gap]="{ rows: 4, cols: 0 }" [cols]="['repeat(5,minmax(0,1fr))']">

          <kendo-gridlayout-item [colSpan]="2">
            <h6 class="popover-data-title">Company:</h6>
          </kendo-gridlayout-item>
          <kendo-gridlayout-item [colSpan]="3">
            <p class="popover-data-value">
              {{ data?.BillToBranch?.Company?.name || '-' }}
            </p>
          </kendo-gridlayout-item>

          <kendo-gridlayout-item [colSpan]="2">
            <h6 class="popover-data-title">Branch Description:</h6>
          </kendo-gridlayout-item>
          <kendo-gridlayout-item [colSpan]="3">
            <p class="popover-data-value">
              {{ data?.BillToBranch?.additionalInformation || '-' }}
            </p>
          </kendo-gridlayout-item>

          <kendo-gridlayout-item [colSpan]="2">
            <h6 class="popover-data-title">Bill To:</h6>
          </kendo-gridlayout-item>
          <kendo-gridlayout-item [colSpan]="3">
            <p class="popover-data-value">
              {{ (data?.BillTo | fullName) || '-' }}
            </p>
          </kendo-gridlayout-item>

          <kendo-gridlayout-item [colSpan]="2">
            <h6 class="popover-data-title">Emails:</h6>
          </kendo-gridlayout-item>
          <kendo-gridlayout-item [colSpan]="3">
            <p class="popover-data-value">
              <app-email-phone-view *ngFor="let email of data?.BillTo?.Emails" [wrapText]="false" [email]="email">
              </app-email-phone-view>
            </p>
          </kendo-gridlayout-item>

          <kendo-gridlayout-item [colSpan]="2">
            <h6 class="popover-data-title">Phones:</h6>
          </kendo-gridlayout-item>
          <kendo-gridlayout-item [colSpan]="3">
            <p class="popover-data-value">
              <app-email-phone-view *ngFor="let phone of data?.BillTo?.Phones" [wrapText]="false" [phone]="phone">
              </app-email-phone-view>
            </p>
          </kendo-gridlayout-item>

          <kendo-gridlayout-item [colSpan]="2">
            <h6 class="popover-data-title">Addresses:</h6>
          </kendo-gridlayout-item>
          <kendo-gridlayout-item [colSpan]="3">
            <p class="popover-data-value">
              <app-address-view [address]="data?.BillTo?.BillingAddress">
              </app-address-view>
            </p>
          </kendo-gridlayout-item>
        </kendo-gridlayout>
      </ng-template>
    </div>
  </ng-template>
</kendo-popover>
